// extracted by mini-css-extract-plugin
export var active = "_1c-d";
export var blink = "_1c-e";
export var container = "_1c-5";
export var controls = "_1c-0";
export var controlsRight = "_1c-1";
export var fakeCursor = "_1c-c";
export var hidden = "_1c-b";
export var quillContainerSmall = "_1c-7";
export var quillEditor = "_1c-6";
export var quillEditorSmall = "_1c-8";
export var quillFormatButtons = "_1c-a";
export var quillToolbar = "_1c-9";
export var removePadding = "_1c-2";
export var state = "_1c-3";
export var stateTitle = "_1c-4";